import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Spinner from '@chama/ui-components/components/Spinner';
import variables from '@chama/statics/stylesheets/variables';

import './LoadingOverlay.css';

export default function LoadingOverlay({ withText, isOpaque, className }) {
  return (
    <div
      className={classnames(
        'LoadingOverlay',
        {
          'LoadingOverlay--opaque': isOpaque,
        },
        className,
      )}
    >
      <div>
        {withText && (
          <h3>
            <FormattedMessage id="loading" />
          </h3>
        )}
        <Spinner color={variables.default['--chama-blue']} />
      </div>
    </div>
  );
}
LoadingOverlay.defaultProps = {
  isOpaque: false,
  withText: false,
  className: '',
};
LoadingOverlay.propTypes = {
  isOpaque: PropTypes.bool,
  withText: PropTypes.bool,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ../ui-components/components/LoadingOverlay/LoadingOverlay.jsx